'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FlaggedFund = require('./FlaggedFund.css');

var _FlaggedFund2 = _interopRequireDefault(_FlaggedFund);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import moment from 'moment'

var FlaggedFund = (_dec = (0, _reactCssModules2.default)(_FlaggedFund2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FlaggedFund, _Component);

  function FlaggedFund(props) {
    (0, _classCallCheck3.default)(this, FlaggedFund);
    return (0, _possibleConstructorReturn3.default)(this, (FlaggedFund.__proto__ || (0, _getPrototypeOf2.default)(FlaggedFund)).call(this, props));
  }

  (0, _createClass3.default)(FlaggedFund, [{
    key: 'render',
    value: function render() {
      function renderStatCount(tip, count, label) {
        return _react2.default.createElement(
          'div',
          {
            styleName: 'stat',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': tip,
            'data-html': true,
            'data-place': 'bottom',
            'data-for': 'flaggedfund-tooltip'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'stat-count-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'stat-count' },
              count
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stat-label' },
            label
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        renderStatCount(_format2.default.tooltipHtml('Number of funds analyzed and scored from this family.'), _format2.default.number(this.props.totalFunds), 'funds scored'),
        renderStatCount(_format2.default.tooltipHtml('Assets under management by funds analyzed from this family.'), _format2.default.money(this.props.assets, true, 'USD', true), 'in assets analyzed'),
        _react2.default.createElement(_reactTooltip2.default, { id: 'flaggedfund-tooltip' })
      );
    }
  }]);
  return FlaggedFund;
}(_react.Component), _class2.propTypes = {
  totalFunds: _react.PropTypes.number,
  assets: _react.PropTypes.number
}, _temp)) || _class);
exports.default = FlaggedFund;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FlaggedFund/FlaggedFund.js
// module id = 1293
// module chunks = 0